import React from "react";
import "./Ecommerce.css";
import ecommercemain from "./Products/ecom-hero.jpg";
import Ecommerce1 from "./Products/ecom1.jpg";
import Ecommerce2 from "./Products/ecom2.jpg";
import { Helmet } from "react-helmet-async";
import Banner from "../../Banner/Banner";

const EcommercePage = () => {
  return (
    <>
      <Helmet>
        <title>E-Commerce Website Solutions for Online Business</title>

        <meta
          name="description"
          content="KitKat Tech provides e-commerce website solutions including secure payment integration, user-friendly design and scalable features to grow your online business."
        />
        <meta
          name="keywords"
          content="E-commerce, Web store, Online shopping, Payment gateway, Online business, Shopping website, Online store, E-commerce company, Online sales, Digital store, Store design, E-commerce services, Retail software"
        />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/ecommerce-website-development" />

      </Helmet>



      {/* Hero Section */}
      <Banner image={ecommercemain} alt="E-commerce" />

      {/* Content Section */}
      <div className="product_cont">

        <div className="career_p">
          <h1 className="product_title">E-Commerce Website Solutions for Growing Businesses</h1>
          <p className="cont_para_style">
            At KitKat Software Technologies, we specialize in developing powerful and user-friendly
            e-commerce platforms tailored to businesses of all sizes. Our goal is to create visually
            appealing, highly functional websites that present your products in a clear, organized,
            and engaging manner. We focus on delivering a smooth and convenient shopping
            experience that keeps customers satisfied and encourages repeat purchases. From
            secure payment gateways to simplified checkout processes, we ensure safe, reliable, and
            hassle-free transactions that help you reach customers both locally and globally.
          </p>
          <div className="img_pro">
            <img
              src={Ecommerce1}
              width="100%"
              height="100%"
              className="img1"
              alt="Ecommerce-website"
              style={{ objectFit: "cover" }}
            />
          </div>
          <p className="cont_para_style">
            As one of the leading web design companies in Coimbatore, we follow a strategic and
            personalized approach for every project. We invest time in understanding your business
            model, target audience, promotional strategies, and competitive landscape before
            crafting a customized solution. This allows us to design websites that not only reflect
            your brand identity but also support long-term business growth and digital success.
          </p>
          <p className="cont_para_style">
            Beyond e-commerce development, we offer comprehensive digital marketing services
            designed to boost your online visibility and attract potential customers. Our
            result-driven strategies include search engine optimization (SEO), social media
            marketing, and performance campaigns that increase traffic, generate leads, and
            maximize sales. At KitKat Software Technologies, we combine innovation, technology,
            and strategy to deliver measurable results and help your business thrive in the
            competitive online marketplace.
          </p>
          <div className="img_pro">
            <img
              src={Ecommerce2}
              width="100%"
              height="100%"
              alt="Digital Marketing"
              className="img1"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EcommercePage;
